import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Notification } from '@aid/notifications/types/classes';

@Component({
  selector: 'aid-notifications-list',
  template: `
    <div
      class="overflow full-height aid-layout-column"
      infinite-scroll
      [infiniteScrollDistance]="2"
      [infiniteScrollUpDistance]="1000"
      [infiniteScrollThrottle]="300"
      [scrollWindow]="false"
      (scrolled)="onScroll()"
    >
      @if (notifications) {
        @if (notifications.length !== 0) {
          <div class="padding-horizontal-32">
            <div class="full-width aid-layout-row aid-layout-align-end">
              <span class="mat-subtitle-2 pointer" (click)="onReadAll()">
                {{ 'mark-all-read' | translate | sentancecase }}
              </span>
            </div>
            @for (
              notification of notifications;
              track notification;
              let l = $last
            ) {
              <aid-notification-item
                [notification]="notification"
                [last]="l"
                (remove)="onRemove(notification)"
                (select)="onSelect(notification)"
                (read)="onRead(notification)"
                (unread)="onUnread(notification)"
              ></aid-notification-item>
            }
          </div>
        } @else {
          <div
            class="text-center mat-subtitle-1 full-height aid-layout-column aid-layout-align-center-center"
          >
            <mat-icon
              svgIcon="bell_off"
              class="notification__icon-size basic-light-color-300"
            ></mat-icon>
            <span class="mat-headline-5">{{
              'no-notifications' | translate | sentancecase
            }}</span>
          </div>
        }
      }
      @if (loading) {
        <div class="loading aid-layout-row aid-layout-align-center-stretch">
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
      }
    </div>
  `,
  styleUrls: ['./notifications-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NotificationsListComponent implements OnInit {
  @Input() notifications?: Notification[] | null;
  @Input() loading?: boolean | null;

  @Output() loadMore = new EventEmitter();
  @Output() remove = new EventEmitter<Notification>();
  @Output() select = new EventEmitter<Notification>();
  @Output() read = new EventEmitter<Notification>();
  @Output() unread = new EventEmitter<Notification>();
  @Output() readAll = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onScroll() {
    this.loadMore.emit();
  }

  onReadAll() {
    this.readAll.emit();
  }

  onRead(notification: Notification) {
    this.read.emit(notification);
  }

  onUnread(notification: Notification) {
    this.unread.emit(notification);
  }

  onRemove(notification: Notification) {
    this.remove.emit(notification);
  }

  onSelect(notification: Notification) {
    this.select.emit(notification);
  }
}
